export default {
  "logInPage.form.email.placeholder": {
    en: "your.name@domain.com",
    es: "tu@email.com",
  },
  "logInPage.form.password.placeholder": {
    en: "Your password",
    es: "Tu contraseña",
  },
  "logInPage.rememberMe": {
    en: "Remember me for 7 days",
    es: "Recordarme 7 días",
  },
  "logInPage.forgotPassword": {
    en: "I forgot my password",
    es: "He olvidado mi contraseña",
  },
  "logInPage.login": {
    en: "Login",
    es: "Entra",
  },
  "logInPage.login.loading": {
    en: "Logging in...",
    es: "Autenticando...",
  },
  "logInPage.signup": {
    en: "No account yet? Sign in here",
    es: "¿No tienes cuenta? Regístrate aquí.",
  },
  "logInPage.resetPassword.title": {
    en: "Reset password",
    es: "Restablecer contraseña",
  },
  "logInPage.resetPassword.text": {
    en: `Please, provide us your email.
         <br />
         <strong>We'll send you an email to reset your password.</strong>`,
    es: `Por favor, introduce tu dirección de correo electrónico.
         <br />
         <strong>Te enviaremos un email para restablecer tu contraseña.</strong>`,
  },
  "loginPage.resetPassword.form.email.placeholder": {
    en: "Your email",
    es: "Tu email",
  },
  "logInPage.formResetPassword.submit": {
    en: "Reset",
    es: "Enviar",
  },
  "logInPage.formResetPassword.submit.loading": {
    en: "Resetting...",
    es: "Enviando...",
  },
  "logInPage.formResetPassword.back": {
    en: "Go back",
    es: "Volver",
  },
  "signUpPage.form.name.placeholder": {
    en: "Your name",
    es: "Tu nombre",
  },
  "signUpPage.form.lastName.placeholder": {
    en: "Your last name",
    es: "Tus apellidos",
  },
  "signUpPage.form.email.placeholder": {
    en: "your.name@domain.com",
    es: "tu@email.com",
  },
  "signUpPage.form.password.placeholder": {
    en: "Your password",
    es: "Tu contraseña",
  },
  "signUpPage.form.password.patternError": {
    en: "8 to 20 Characters, one number and one letter.",
    es: "8 a 20 Caracteres, un número y una letra.",
  },
  "signUpPage.form.submit": {
    en: "Sign in",
    es: `Regístrate`,
  },
  "signUpPage.form.submit.loading": {
    en: "Signing in...",
    es: `Registrando...`,
  },
  "signUpPage.goLogin": {
    en: "Have an account? Login.",
    es: `¿Ya tienes una cuenta? Entra.`,
  },
  "verifyEmailPage.verifyingEmail": {
    en: "We're verifying your emai. It will take a second.",
    es: "Estamos verificando tu email. Sólo será un segundo.",
  },
  "verifyEmailPage.emailVerified": {
    en: "Your email has been verified, please, go back to login.",
    es: "Tu email ha sido verificado, por favor, vuelve al login para iniciar sesión.",
  },
  "verifyEmailPage.emailNotVerified": {
    en: "We were not able to verify your email.",
    es: "Tu email no ha podido ser verificado.",
  },
  "verifyEmailPage.goToLogin": {
    en: "Go to login page",
    es: "Ir a la página de login",
  },
  "organizationNewCard.form.name.label": {
    en: "What's your business name?",
    es: "¿Cómo se llama tu empresa?",
  },
  "organizationNewCard.form.name.placeholder": {
    en: "e.g: ACME Corp",
    es: "Ejemplo: ACME S.A.",
  },
  "organizationNewCard.form.companySize.title": {
    en: "How many people work on your business?",
    es: "¿Cuántos sois?",
  },
  "organizationNewCard.form.currency.title": {
    en: "Your currency:",
    es: "Tu divisa:",
  },
  "organizationNewCard.form.quoteLanguage.title": {
    en: "Proposals language:",
    es: "Idioma de tus presupuestos:",
  },
  "organizationNewCard.form.additionalData": {
    en: "Add more information",
    es: "Completar más datos",
  },
  "organizationNewCard.form.companySector.titleFreelance": {
    en: "What is your business sector?",
    es: "¿A qué te dedicas?",
  },
  "organizationNewCard.form.companySector.titleCompany": {
    en: "What is your business sector?",
    es: "¿A qué os dedicáis?",
  },
  "organizationNewCard.form.companySector.custom.placeholder": {
    en: "Type here your business sector",
    es: "Escribe aquí tu sector",
  },
  "organizationNewCard.form.companySector.custom.error.required": {
    en: "Please, tell us which is your business sector",
    es: "Por favor, dinos a que sector te dedicas<br/>",
  },
  "organizationNewCard.form.heardAbout.title": {
    en: "How have you get to know us?",
    es: "¿Cómo nos has conocido?",
  },
  "organizationNewCard.form.heardAbout.custom.placeholder": {
    en: "Type here how you knew about us",
    es: "Escribe aquí cómo nos conociste",
  },
  "organizationNewCard.form.heardAbout.custom.error.required": {
    en: "Please, let us know how you knew about us",
    es: "Por favor, dinos cómo nos conociste<br/>",
  },
  "organizationNewCard.form.error": {
    en: "Form has some error, please, check form fields.",
    es: "El formulario contiene algún error, por favor, revisa los campos.",
  },
  "organizationNewCard.form.submit": {
    en: "Next",
    es: "Continuar",
  },
  "organizationCard.signout": {
    en: "Signout",
    es: "Salir",
  },
  "notHaveOrganization.text": {
    en: "Sorry, you don't have organizations linked to your account.",
    es: "Lo sentimos, no tienes organizaciones asociadas a tu cuenta.",
  },
  "createQuoteVersionModal.header.title": {
    en: "Create a new version",
    es: "Crear una nueva versión",
  },
  "createQuoteVersionModal.header.onlyPreview": {
    en: "Do you want just a preview?",
    es: "¿Sólo quieres previsualizarlo?",
  },
  "createQuoteVersionModal.header.clickHere": {
    en: "Click here",
    es: "Pincha aquí",
  },
  "createQuoteVersionModal.header.text": {
    en: "When you click on a accepted or rejected proposal, a new version will be created. You can see changes made at version history.",
    es: "Al clicar en un presupuesto aceptado o rechazado se crea una nueva versión del mismo. Puedes ver en el historial de versiones qué ha cambiado en el presupuesto.",
  },
  "createQuoteVersionModal.form.date.error.required": {
    en: "Choose proposal date<br />",
    es: "Selecciona la fecha del presupuesto<br />",
  },
  "createQuoteVersionModal.form.date.error.noDate": {
    en: "Date is not valid<br />",
    es: "No es una fecha valida<br />",
  },
  "createQuoteVersionModal.form.date.label": {
    en: "Date",
    es: "Fecha",
  },
  "createQuoteVersionModal.form.expirationDate.label": {
    en: "Expiration date",
    es: "Válido hasta",
  },
  "createQuoteVersionModal.form.expirationDate.error.required": {
    en: "Choose proposal expiration date<br />",
    es: "Selecciona la fecha hasta que será válido el presupuesto<br />",
  },
  "createQuoteVersionModal.form.expirationDate.error.noDate": {
    en: "Date is not valid<br />",
    es: "No es una fecha válida<br />",
  },
  "createQuoteVersionModal.form.disableShared.text": {
    en: "Do you want to stop sharing the proposal with your client?",
    es: "¿Quieres dejar de compartir el presupuesto con el cliente?",
  },
  "createQuoteVersionModal.form.disableShared.noShared": {
    en: "proposal not visible to your client",
    es: "No visible para tu cliente",
  },
  "createQuoteVersionModal.form.disableShared.shared": {
    en: "proposal visible to your client",
    es: "Visible para tu cliente",
  },
  "createQuoteVersionModal.form.disableShared.info": {
    en: "Bear in mind, if shared, your client can visit the new version while you're editing it.",
    es: "Ten en cuenta que, si está compartido, tu cliente puede ver la nueva versión del presupuesto mientras lo estás editando.",
  },
  "dashboardPage.searchBar": {
    en: "Search on your proposals",
    es: "Busca entre tus presupuestos",
  },
  "dashboardPage.filterResults": {
    en: ' <i class="zmdi zmdi-filter-list"></i>&nbsp;&nbsp;Filter search results',
    es: ' <i class="zmdi zmdi-filter-list"></i>&nbsp;&nbsp;Filtrar Resultados',
  },
  "dashboardPage.filter.quotesAccepted": {
    en: "Accepted (__$1__)",
    es: "Aceptados (__$1__)",
  },
  "dashboardPage.filter.quotesRejected": {
    en: "Rejected (__$1__)",
    es: "Rechazados (__$1__)",
  },
  "dashboardPage.filter.quotesNonStatus": {
    en: "No status (__$1__)",
    es: "Sin Estado (__$1__)",
  },
  "dashboardPage.filter.include": {
    en: "Include",
    es: "Incluir",
  },
  "Todos": {
    en: "All",
    es: "Todos",
  },
  "Solo Activos": {
    en: "Active only",
    es: "Solo Activos",
  },
  "Solo Archivados": {
    en: "Archived only",
    es: "Solo Archivados",
  },
  "dashboardPage.filter.dateFrom": {
    en: "From",
    es: "Desde",
  },
  "dashboardPage.filter.dateTo": {
    en: "to",
    es: "Hasta",
  },
  "dashboardPage.createQuote": {
    en: "+ CREATE NEW PROPOSAL",
    es: "+ CREAR NUEVO PRESUPUESTO",
  },
  "dashboardPage.orderByDate": {
    en: "Order by date",
    es: "Ordenar por fecha",
  },
  "dashboardPage.noQuotes": {
    en: 'You haven\'t created any proposal yet!<br> Create one clicking on <a href="__$1__">new proposal.</a>',
    es: '¡Ey! ¡Aún no has creado ningún presupuesto!<br>Si quieres crearlo haz clic en <a href="__$1__">nuevo presupuesto.</a>',
  },
  "dashboardPage.noQuotesNoFilteredQuotes": {
    en: "We couldn't find anything using those filters.<br>Wouldn't you have been using Excel for that proposal, uh? Try again!",
    es: "No hemos encontrado nada con esos filtros.<br>¿No lo habrás hecho en Excel, no? ¡Prueba otra vez!",
  },

  "dateLink.placeholder": {
    en: "Choose a date",
    es: "Selecciona una fecha",
  },
  "dateLink.closeText": {
    en: "Close",
    es: "Cerrar",
  },
  "dateLink.clearText": {
    en: "Clear",
    es: "Borrar",
  },
  "dateLink.currentText": {
    en: "Today",
    es: "Hoy",
  },
  "dateLink.selectDate": {
    en: "(Choose a date)",
    es: "(Selecciona una fecha)",
  },
  "dateLink.error.noDate": {
    en: "Choose a date",
    es: "Selecciona una fecha",
  },

  "quoteCard.accepted": {
    en: "ACCEPTED",
    es: "ACEPTADO",
  },
  "quoteCard.rejected": {
    en: "REJECTED",
    es: "RECHAZADO",
  },
  "quoteCard.onePublicView": {
    en: "One time visited",
    es: "Visto 1 vez",
  },
  "quoteCard.publicViews": {
    en: "__$1__ views",
    es: "Visto __$1__ veces",
  },
  "quoteCard.expires": {
    en: "Expires __$1__",
    es: "Vence __$1__",
  },
  "quoteCard.expired": {
    en: "EXPIRED",
    es: "VENCIDO",
  },
  "quoteCard.version": {
    en: "Version __$1__",
    es: "Versión __$1__",
  },
  "quoteCard.showVersion": {
    en: "Show v__$1__",
    es: "Ver v__$1__",
  },
  "quoteCard.activity": {
    en: "Activity",
    es: "Actividad",
  },
  "quoteCard.preview": {
    en: "Preview",
    es: "Previsualizar",
  },
  "quoteCard.share": {
    en: "Share",
    es: "Compartir",
  },
  "quoteCard.changeStatus": {
    en: "Change status",
    es: "Cambiar estado",
  },
  "quoteCard.cloneQuote": {
    en: "Clone proposal",
    es: "Duplicar presupuesto",
  },
  "quoteCard.clonedQuote": {
    en: "Copied from",
    es: "Copia de",
  },
  "quoteCard.status.accepted": {
    en: '<i class="zmdi zmdi-circle text-success m-r-5"></i> Accepted',
    es: '<i class="zmdi zmdi-circle text-success m-r-5"></i> Aceptado',
  },
  "quoteCard.status.rejected": {
    en: '<i class="zmdi zmdi-circle text-danger m-r-5"></i> Rejected',
    es: '<i class="zmdi zmdi-circle text-danger m-r-5"></i> Rechazado',
  },
  "quoteCard.archiveQuote": {
    en: "Archive proposal",
    es: "Archivar presupuesto",
  },
  "quoteCard.unarchiveQuote": {
    en: "Return to active proposals",
    es: "Devolver a presupuestos activos",
  },
  "quoteCard.deleteQuote": {
    en: "Delete",
    es: "Eliminar",
  },
  "changeOrganizationModal.header": {
    en: "My businesses",
    es: "Mis organizaciones",
  },
  "changeOrganizationModal.defaultOrganization": {
    en: "Default business",
    es: "Organización por defecto",
  },
  "changeOrganizationModal.goToOrganization": {
    en: "Go to business",
    es: "Ir a organización",
  },
  "changeOrganizationModal.owner": {
    en: "Owner",
    es: "Dueño",
  },
  "changeOrganizationModal.guest": {
    en: "Guest",
    es: "Invitado",
  },
  "changeOrganizationModal.createOrganization": {
    en: "Create a new business",
    es: "Crear nueva organización",
  },
  "sidebar.myOrganizations": {
    en: "My businesses",
    es: "Mis organizaciones",
  },
  "sidebar.start": {
    en: "Dashboard",
    es: "Inicio",
  },
  "sidebar.newQuote": {
    en: "New proposal",
    es: "Nuevo presupuesto",
  },
  "sidebar.contacts": {
    en: "Contacts",
    es: "Contactos",
  },
  "sidebar.library": {
    en: "Library",
    es: "Biblioteca",
  },
  "sidebar.tariffs": {
    en: "Rates",
    es: "Tarifas",
  },
  "sidebar.costs": {
    en: "Costs",
    es: "Costes",
  },
  "sidebar.settings": {
    en: "Settings",
    es: "Ajustes",
  },
  "sidebar.link": {
    en: "Connect",
    es: "Vincular",
  },
  "contactCard.editContact": {
    en: "Edit contact",
    es: "Editar contacto",
  },
  "contactCard.removeContact": {
    en: "Remove contact",
    es: "Borrar contacto",
  },
  "contactModal.header.new": {
    en: "New contact",
    es: "Nuevo contacto",
  },
  "contactModal.header.edit": {
    en: "Edit contact",
    es: "Editar contacto",
  },
  "contactModal.form.name": {
    en: "First Name",
    es: "Nombre*",
  },
  "contactModal.form.lastName": {
    en: "Last name",
    es: "Apellidos",
  },
  "contactModal.form.email": {
    en: "Email",
    es: "Email",
  },
  "contactModal.form.email.error.alreadyExists": {
    en: "Contact with same email already exists",
    es: "Ya existe un contacto con este email",
  },
  "contactModal.form.additionalData": {
    en: "Add more information",
    es: "Completar más datos",
  },
  "contactModal.form.company": {
    en: "Business",
    es: "Empresa",
  },
  "contactModal.form.appointment": {
    en: "Job title",
    es: "Cargo",
  },
  "contactModal.form.nif": {
    en: "ID/Tax no.",
    es: "NIF",
  },
  "contactModal.form.primaryPhone": {
    en: "Primary phone no.",
    es: "Teléfono Principal",
  },
  "contactModal.form.secondaryPhone": {
    en: "Secondary phone no.",
    es: "Teléfono Secundario",
  },
  "contactModal.form.addressLine1": {
    en: "Address",
    es: "Dirección",
  },
  "contactModal.form.addressLine2": {
    en: "Address (Addtional information)",
    es: "Dirección (datos adicionales)",
  },
  "contactModal.form.zipOrPostalCode": {
    en: "Postal code",
    es: "Código Postal",
  },
  "contactModal.form.city": {
    en: "City",
    es: "Población",
  },
  "contactModal.form.stateOrProvince": {
    en: "State or province",
    es: "Provincia o Estado",
  },
  "contactModal.form.country": {
    en: "Country",
    es: "País",
  },
  "contactModal.form.currency": {
    en: "Currency",
    es: "Divisa",
  },
  "contactModal.form.currency.tooltip": {
    en: "Default currency for this contact",
    es: "Divisa por defecto para este contacto",
  },
  "contactModal.form.submit": {
    en: "Save contact",
    es: "Guardar contacto",
  },
  "libraryContactsPage.title": {
    en: "Contacts",
    es: "Tus contactos",
  },
  "libraryContactsPage.header": {
    en: "Find the people who you're going to send the proposals. Create new contacts or edit your contacts.",
    es: "Encuentra a las personas a las que enviarás tus presupuestos. Crea nuevos contactos o edita los que ya tienes.",
  },
  "libraryContactsPage.newContact": {
    en: "New contact",
    es: "Nuevo Contacto",
  },
  "libraryContactsPage.search.placeholder": {
    en: "Search on your contacts",
    es: "Buscar entre tus contactos",
  },
  "libraryContactsPage.searchResults": {
    en: "Search results: ",
    es: "Resultados de la búsqueda:",
  },
  "libraryContactsPage.noResults": {
    en: "Ouch! We couldn't find any contact with that description. <br> Try again!",
    es: "¡Ouch! No hemos encontrado ningún contacto con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryContactsPage.noContacts": {
    en: "No contacts yet!<br>You can create a new one clicking on the right button<br> and start sending winning proposals.",
    es: "¡Sin contacto de los contactos!<br>Crea uno nuevo pinchando en el botón de la derecha<br>y comienza a enviar presupuestos ganadores.",
  },
  "costFolder.main": {
    en: "Main",
    es: "Principal",
  },
  "costFolderModal.header": {
    en: "Folder",
    es: "Carpeta",
  },
  "costFolderModal.form.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },
  "costModal.header": {
    en: "Cost",
    es: "Coste",
  },
  "costModal.form.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },
  "costModal.form.unit.placeholder": {
    en: "Unit",
    es: "Und. de medida",
  },
  "costModal.form.unit.error.required": {
    en: "Type cost unit (e.g: units, hours, metres, etc..)<br />",
    es: "Escribe la unidad de medida del coste (Ej: unidades, horas, metros, etc...)<br />",
  },
  "costModal.form.price.placeholder": {
    en: "Price",
    es: "Precio",
  },
  "costModal.form.price.error.number": {
    en: "It has to be a number<br />",
    es: "Debe ser un número<br />",
  },
  "costModal.form.price.error.min": {
    en: "It has to be positive<br />",
    es: "Debe ser positivo<br />",
  },
  "costModal.form.price.error.max": {
    en: "It's to high (max: 9.999.999.999,99)<br />",
    es: "Demasiado grande (max: 9.999.999.999,99)<br />",
  },
  "costModal.form.price.error.maxLength": {
    en: "It's too long (max: 9.999.999.999,99)<br />",
    es: "Demasiado largo (max: 9.999.999.999,99)<br />",
  },
  "costModal.form.comments.placeholder": {
    en: "Comments",
    es: "Notas relacionadas con el coste",
  },
  "importCostsCsvModal.header.title": {
    en: "Import Costs using a CSV file",
    es: "Importar Costes en CSV",
  },
  "importCostsCsvModal.header.templateLink": {
    en: "Download costs CSV template",
    es: "Descargar plantilla de costes en csv",
  },
  "importCostsCsvModal.header.tooltip": {
    en: "You can download a compatible template in .csv format and edit your costs on it",
    es: "Puedes descargar una plantilla compatible en formato .csv y editar tus costes sobre ella",
  },
  "importCostsCsvModal.body.selectFile": {
    en: "Choose a file",
    es: "Seleccionar archivo",
  },
  "importCostsCsvModal.body.import": {
    en: "Import CSV",
    es: "Importar CSV",
  },
  "libraryCostsPage.costs": {
    en: "Costs",
    es: "Costes",
  },
  "libraryCostsPage.description": {
    en: "Save and categorize all your costs, that will help you to be more profitable.",
    es: "Aquí podrás almacenar y categorizar todos tus costes, lo que te ayudará a ser más rentable.",
  },
  "libraryCostsPage.importCsv": {
    en: "Import costs",
    es: "Importar costes",
  },
  "libraryCostsPage.importCsv.tooltip": {
    en: "Import your costs in CSV format",
    es: "Impota tus costes en CSV",
  },
  "libraryCostsPage.newCost": {
    en: "New cost",
    es: "Nuevo coste",
  },
  "libraryCostsPage.newCostFolder": {
    en: "New folder",
    es: "Nueva carpeta",
  },
  "libraryCostsPage.search": {
    en: "Search cost",
    es: "Buscar entre tus costes",
  },
  "libraryCostsPage.searchResults": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "libraryCostsPage.noResults": {
    en: "Ouch! We couldn't find any cost with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryCostsPage.noCostsYet": {
    en: "There is no cost yet!",
    es: "¡Aún no tienes costes!",
  },
  "moveCostModal.header": {
    en: "Move to...",
    es: "Mover a...",
  },
  "moveCostModal.newFolder": {
    en: "New folder",
    es: "Nueva carpeta",
  },
  "moveCostModal.move": {
    en: "Move",
    es: "Mover",
  },
  "selectCostModal.header": {
    en: "Choose a cost",
    es: "Selecciona un coste",
  },
  "selectCostModal.search.placeholder": {
    en: "Search on your costs",
    es: "Buscar entre tus costes",
  },
  "selectCostModal.newCost": {
    en: "New cost",
    es: "Nuevo coste",
  },
  "selectCostModal.newCostFolder": {
    en: "New folder",
    es: "Nueva carpeta",
  },
  "selectCostModal.searchResults": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "selectCostModal.noResults": {
    en: "Ouch! We couldn't find any cost with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción <br>¡Prueba otra vez!",
  },
  "selectCostModal.noCostsYet": {
    en: "There is no cost yet!",
    es: "¡Aún no tienes costes!",
  },
  "selectCostModal.showMore": {
    en: "Show more",
    es: "Ver más",
  },
  "libraryTariffsPage.manageTariffs": {
    en: "Manage your rates",
    es: "Gestiona tus tarifas",
  },
  "libraryTariffsPage.description": {
    en: "Here, you can find the rates that you created. Reuse, edit or create a new one.",
    es: "Aquí encontrarás las tarifas que hayas creado. Reutiliza, edita o crea una nueva.",
  },
  "libraryTariffsPage.newTariff": {
    en: "New rate",
    es: "Nueva tarifa",
  },
  "libraryTariffsPage.search.placeholder": {
    en: "Search on your rates",
    es: "Buscar entre tus tarifas",
  },
  "libraryTariffsPage.searchResults": {
    en: "Search results: ",
    es: "Resultados de la búsqueda:",
  },
  "libraryTariffsPage.noResults": {
    en: "Ouch! We couldn't find any rate with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ninguna tarifa con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryTariffsPage.noTariffsYet": {
    en: "There is no rates yet!",
    es: "¡Aún no tienes tarifas!",
  },
  "libraryTariffsPage.costOnTariff.placeholder": {
    en: "This rate has related costs",
    es: "Esta tarifa tiene costes asociados",
  },
  "tariffForm.newTariff": {
    en: "New rate",
    es: "Nueva tarifa",
  },
  "tariffForm.description.label": {
    en: "Description",
    es: "Descripción o concepto",
  },
  "tariffForm.margin.label": {
    en: "Markup",
    es: "Margen",
  },
  "tariffForm.margin.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.margin.error.max": {
    en: "It is too high (max: 10.000)<br/>",
    es: "Demasiado alto (max: 10.000)<br/>",
  },
  "tariffForm.price.label": {
    en: "Price",
    es: "Precio",
  },
  "tariffForm.price.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.price.error.min": {
    en: "It has to be positive or zero<br/>",
    es: "Debe ser positivo o cero<br/>",
  },
  "tariffForm.price.error.max": {
    en: "It is too high (max __$1__)<br/>",
    es: "Demasiado alto (max: __$1__)<br/>",
  },
  "tariffForm.addCosts.label": {
    en: "Add costs related with the rate",
    es: "Añade costes relacionados con la tarifa",
  },
  "tariffForm.addCosts.add": {
    en: "Add a new cost",
    es: "Añadir un nuevo coste",
  },
  "tariffForm.addCosts.quantity.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.addCosts.quantity.error.min": {
    en: "It has to be positive<br/>",
    es: "Debe ser positivo<br/>",
  },
  "tariffForm.addCosts.quantity.error.max": {
    en: "It is too high (max: 9.999.999.99)<br/>",
    es: "Demasiado alto (max: 9.999.999.99)<br/>",
  },
  "tariffForm.addCosts.quantity.error.maxLength": {
    en: "It is too long (max: 9.999.999.99)<br/>",
    es: "Demasiado largo (max: 9.999.999.99)<br/>",
  },
  "brandingSettings.description": {
    en: "Welcome to the brand centre. On it you can set up the main elements of the look and feel of your proposals: Choose the best font for your proposals and the corporate colors that will make you sell more and better.",
    es: "Bienvenido al centro de tu marca. Aquí podrás configurar los elementos principales de la imagen de tus presupuestos: Elige la mejor fuente para tus presupuestos y los colores corporativos que te harán vender más y mejor.",
  },
  "brandingSettings.typography": {
    en: "Typography",
    es: "Tipografía",
  },
  "brandingSettings.config.title": {
    en: "Title",
    es: "Título",
  },
  "brandingSettings.config.subtitle": {
    en: "Subtitle",
    es: "Subtítulo",
  },
  "brandingSettings.config.paragraph": {
    en: "Paragraph",
    es: "Párrafo",
  },
  "brandingSettings.config.color": {
    en: "Colour",
    es: "Color",
  },
  "brandingSettings.config.main": {
    en: "Main",
    es: "Principal",
  },
  "brandingSettings.config.secondary": {
    en: "Secondary",
    es: "Secundario",
  },
  "customDomainSettings.current": {
    en: "<strong>Your current domain for the public view is:</strong><br>",
    es: "<strong>Tu dominio actual para la vista pública es:</strong><br>",
  },
  "customDomainSettings.newDomain": {
    en: "<strong>Your new domain will be:</strong><br>",
    es: "<strong>Tu nuevo dominio será:</strong><br>",
  },
  "customDomainSettings.verifying": {
    en: "<strong>Verifying...</strong>",
    es: "<strong>Verificando...</strong>",
  },
  "customDomainSettings.pending": {
    en: "PENDING",
    es: "PENDIENTE",
  },
  "customDomainSettings.ok24Hours": {
    en: "<small>Well done! Domain has been sucessfully configured and will be active within 24 hours.</small>",
    es: "<small>¡Bien! La configuración es correcta. En un máximo de 24 horas tu nuevo dominio estará activo.</small>",
  },
  "customDomainSettings.error.label": {
    en: "ERROR",
    es: "ERROR",
  },
  "customDomainSettings.error.description": {
    en: "<small>Oops! Something went wrong. Please check your CNAME settings on your domain provider.</small>",
    es: "<small>¡Ups! Algo ha salido mal. Revisa tu configuración de DNS de tipo CNAME.</small>",
  },
  "customDomainSettings.newDnsRecord": {
    en: "Now, add a new DNS record of type CNAME with this value:",
    es: "Ahora añade un nuevo registro DNS de tipo CNAME apuntando a:",
  },
  "customDomainSettings.verify": {
    en: "Verify settings",
    es: "Verificar configuración",
  },
  "customDomainSettings.requestedCustomDomain": {
    en: "If you want to change your domain again, do it on the field below. You can also reset to default domain.",
    es: "Si quieres  cambiar tu dominio de nuevo, solicítalo en el campo a continuación. También puedes restablecer el dominio por defecto.",
  },
  "customDomainSettings.typeDomain": {
    en: "Type your new domain for your proposals here:",
    es: "Escribe aquí tu nuevo dominio para tus presupuestos:",
  },
  "customDomainSettings.resetToDefault": {
    en: "Reset domain to default",
    es: "Restablecer dominio por defecto",
  },
  "customDomainSettings.form.customDomainUrl.placeholder": {
    en: "e.g: proposals.yourdomain.com",
    es: "Ejemplo: presupuestos.tudominio.com",
  },
  "customDomainSettings.form.customDomainUrl.error.validateDomain": {
    en: "Invalid domain<br />",
    es: "Escribe un nombre de dominio válido<br />",
  },
  "customDomainSettings.form.submit": {
    en: "Request",
    es: "Solicitar",
  },
  "organizationProfile.form.name.label": {
    en: "Business Name",
    es: "Nombre de tu organización",
  },
  "organizationProfile.form.name.placeholder": {
    en: "e.g: ACME Corp",
    es: "Ejemplo: ACME S.A.",
  },
  "organizationProfile.form.url.label": {
    en: "URL",
    es: "URL",
  },
  "organizationProfile.form.url.error.required": {
    en: "La url de la organización es obligatoria<br />",
    es: "Organization url is required<br />",
  },
  "organizationProfile.form.url.error.pattern": {
    en: "Only lowercase letters, numbers, and hyphens<br/>",
    es: "Solo minúsculas, números, y guiones<br/>",
  },
  "organizationProfile.form.url.error.uniqueSlug": {
    en: "This slug was already used<br/>",
    es: "Este slug ya ha sido utilizado<br/>",
  },
  "organizationProfile.form.addressLine1.label": {
    en: "Address",
    es: "Dirección",
  },
  "organizationProfile.form.addressLine1.placeholder": {
    en: "e.g: 4 Pennsylvania Plaza",
    es: "Ejemplo: Plaza Mayor 5, 4ºD",
  },
  "organizationProfile.form.addressLine2.label": {
    en: "Address (Additional Information)",
    es: "Dirección (datos adicionales)",
  },
  "organizationProfile.form.addressLine2.placeholder": {
    en: "e.g: Madison Square Garden",
    es: "Ejemplo: Edificio de usos múltiples.",
  },
  "organizationProfile.form.zipOrPostalCode.label": {
    en: "Postal Code",
    es: "Código postal",
  },
  "organizationProfile.form.zipOrPostalCode.placeholder": {
    en: "e.g: 10001",
    es: "Ejemplo: 47003",
  },
  "organizationProfile.form.city.label": {
    en: "City",
    es: "Ciudad",
  },
  "organizationProfile.form.city.placeholder": {
    en: "e.g: New York City",
    es: "Ejemplo: Valladolid",
  },
  "organizationProfile.form.stateOrProvince.label": {
    en: "State or Province",
    es: "Provincia/Región",
  },
  "organizationProfile.form.stateOrProvince.placeholder": {
    en: "e.g: New York",
    es: "Ejemplo: Valladolid",
  },
  "organizationProfile.form.country.label": {
    en: "Country",
    es: "País",
  },
  "organizationProfile.form.country.placeholder": {
    en: "Choose a country",
    es: "Selecciona un país",
  },
  "organizationProfile.form.web.label": {
    en: "Web",
    es: "Web",
  },
  "organizationProfile.form.web.placeholder": {
    en: "e.g: https://example.com",
    es: "Ejemplo: https://example.com",
  },
  "organizationProfile.form.phone.label": {
    en: "Primary Phone Number",
    es: "Teléfono",
  },
  "organizationProfile.form.phone.placeholder": {
    en: "e.g: 212.465.6000",
    es: "Ejemplo: 983 02 65 89",
  },
  "organizationProfile.form.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "organizationSettingsPage.header.title": {
    en: "Settings",
    es: "Tus ajustes",
  },
  "organizationSettingsPage.header.description": {
    en: "Modify your business settings: business information, team, look and feel of your proposals.",
    es: "Aquí podrás modificar la configuración de tu organización: datos del negocio, equipo y apariencia de tus presupuestos.",
  },
  "organizationSettingsPage.updateImage": {
    en: "Update business logo",
    es: "Actualizar foto de la organización",
  },
  "organizationSettingsPage.updateImage.recommendedSize": {
    en: "Recommended image size is 400x300 pixels",
    es: "El tamaño de la imagen recomendado es 400x300 píxels",
  },
  "organizationSettingsPage.info": {
    en: "Information",
    es: "Datos",
  },
  "organizationSettingsPage.info.tooltip": {
    en: "Fill the basic contact information of your business.",
    es: "Rellena la información básica de contacto de tu empresa.",
  },
  "organizationSettingsPage.users": {
    en: "Users",
    es: "Usuarios",
  },
  "organizationSettingsPage.users.tooltip": {
    en: "Do you prefer to work in a team? Invite your fellow coworkers and co-create proposals.",
    es: "¿Prefieres trabajar en equipo? Invita a tus colaboradores y cread presupuestos juntos.",
  },
  "organizationSettingsPage.quotes": {
    en: "Proposals",
    es: "Presupuestos",
  },
  "organizationSettingsPage.quotes.tooltip": {
    en: "Set up the defaults for your proposals: currency, language, taxes...",
    es: "Configura los datos generales de tus presupuestos: divisa, idioma, impuestos...",
  },
  "organizationSettingsPage.lookAndFeel": {
    en: "Look and Feel",
    es: "Apariencia",
  },
  "organizationSettingsPage.lookAndFeel.tooltip": {
    en: "Do you want your proposals to be nice? This is the place to do so.",
    es: "¿Quieres que tus presupuestos sean bonitos? Este es el lugar para hacerlo.",
  },
  "organizationSettingsPage.customDomain": {
    en: "Custom domain",
    es: "Dominio",
  },
  "organizationSettingsPage.customDomain.tooltip": {
    en: "Set up your own domain so your proposals can be an extension of your website",
    es: "Configura el dominio para que tus presupuestos sean una extensión de tu web",
  },
  "settings.region.title": {
    en: "Region Settings",
    es: "Configuración Regional",
  },
  "settings.region.description": {
    en: "In this section you can set up language and timezone.",
    es: "En esta sección puedes definir el idioma de la aplicación y la zona horaria.",
  },
  "settings.region.language": {
    en: "Language",
    es: "Idioma",
  },
  "settings.region.timezone": {
    en: "Timezone",
    es: "Zona horaria",
  },
  "settings.quote.valid.title": {
    en: "Proposals expiration (days)",
    es: "Validez de los presupuestos",
  },
  "settings.quote.valid.description": {
    en: "Set up a default expiration time for proposal, so you won't have to worry about setting the expiration date every time you create a new proposal.",
    es: "Te permite establecer el periodo de validez por defecto de un presupuesto, así no tendrás que preocuparte de poner la fecha de validez cada vez que crees un nuevo presupuesto.",
  },
  "settings.quote.series.title": {
    en: "Proposal number",
    es: "Número del presupuesto",
  },
  "settings.quote.series.description": {
    en: "Proposal number is used to identify a proposal. A proposal number is made up of a prefix followed by a number that is sequential and automatically incremented each time you create a new proposal.",
    es: "El número de presupuesto sirve para identificar un presupuesto. Un número de presupuesto se compone de un prefijo seguido por un número que es secuencial y se incrementa automáticamente cada vez que creas un nuevo presupuesto.",
  },
  "settings.quote.series.prefix": {
    en: "Prefix",
    es: "Prefijo",
  },
  "settings.quote.series.nextNumber": {
    en: "Following proposal number",
    es: "Número siguiente",
  },
  "settings.quote.series.default": {
    en: "By default",
    es: "Por defecto",
  },
  "settings.quote.currency.title": {
    en: "Proposals currency",
    es: "Divisa de los presupuestos",
  },
  "settings.quote.currency.description": {
    en: "It allows you to set the default currency for your business.",
    es: "Te permite establecer la divisa por defecto de la organización.",
  },
  "settings.quote.currency.tooltip": {
    en: "You can override on proposal creation or on contact information",
    es: "Podrás usar otras por contactos o por presupuestos",
  },
  "settings.quote.emailToCustomerOnAccept.title": {
    en: "Acceptance Email",
    es: "Email de aceptación",
  },
  "settings.quote.emailToCustomerOnAccept.description": {
    en: "Send a default email your clients when they accept your proposal.",
    es: "Envía un correo por defecto a tus clientes cuando aprueban tus presupuestos.",
  },
  "settings.quote.language.title": {
    en: "Proposals language",
    es: "Idioma de los presupuestos",
  },
  "settings.quote.language.description": {
    en: "It allows you to set default proposal language. Pricing table header and proposal public view will change to this language.",
    es: "Te permite establecer el idioma por defecto de tus presupuestos. Las cabeceras de la tabla de precios y la previsualización cambiarán al idioma establecido.",
  },
  "settings.quote.signature.title": {
    en: "Proposals signature",
    es: "Firma de los presupuestos",
  },
  "settings.quote.signature.description": {
    en: "Set the name of the person who will sign the proposals for your business and upload his/her signature as an image. Ratio for image is 4:3.",
    es: "Define el nombre del responsable que va a firmar los presupuestos y sube su firma en una imagen. La proporción utilizada es de 4:3.",
  },
  "settings.quote.approveFromPublicView.title": {
    en: "Accept Proposals",
    es: "Aceptar presupuestos",
  },
  "settings.quote.approveFromPublicView.description": {
    en: 'It allows you to set by default the "Accept" button on public view whenever you create a new proposal.',
    es: 'Te permite establecer si el botón de "Aceptar" presupuesto en la vista pública está disponible por defecto al crear un nuevo presupuesto.',
  },
  "settings.quote.pdfDownloadable.title": {
    en: "PDF downloadable by client",
    es: "PDF descargable por el cliente",
  },
  "settings.quote.pdfDownloadable.description": {
    en: "It allows you to set by default pdf downloadable by client whenever you create a new proposal.",
    es: "Te permite establecer si la descarga del pdf por el cliente está disponible por defecto al crear un nuevo presupuesto.",
  },
  "settings.quote.taxes.title": {
    en: "Taxes",
    es: "Impuestos",
  },
  "settings.quote.taxes.description": {
    en: "In this section you can set taxes so that you have them available when you are editing pricing tables of your proposals.",
    es: "En esta sección puedes definir tus impuestos para que los tengas disponibles cuando estás haciendo tu tabla de precios en el presupuesto.",
  },
  "settingsExpirationDate.form.label": {
    en: "Days",
    es: "Días",
  },
  "settingsExpirationDate.form.error.number": {
    en: "Time limit has to be a number<br/>",
    es: "El periodo de validez debe ser un número<br/>",
  },
  "settingsExpirationDate.form.error.min": {
    en: "Time period has to be higher</br>",
    es: "Periodo de validez debe ser mayor<br/>",
  },
  "settingsExpirationDate.form.error.max": {
    en: "Time limit is too high<br/>",
    es: "Periodo de validez demasiado prolongado<br/>",
  },
  "settingsExpirationDate.form.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "settingsQuoteNumberRow.form.number.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "settingsQuoteNumberRow.form.number.error.min": {
    en: "It's too low (min: 1)<br/>",
    es: "Demasiado pequeño (min: 1)<br/>",
  },
  "settingsQuoteNumberRow.form.number.error.max": {
    en: "It's too high (max: 999999)<br/>",
    es: "Demasiado grande (max: 999999)<br/>",
  },
  "settingsQuoteNumberRow.form.number.error.valueGreaterOrEqualThan": {
    en: "It has to be equal or higher than __$1__<br/>",
    es: "Debe ser mayor o igual que __$1__<br/>",
  },
  "settingsSignature.title": {
    en: "Signature",
    es: "Responsable de la firma",
  },
  "settingsSignature.form.contact.error.minLength": {
    en: "It has to be longer than 3 characters<br />",
    es: "Debe de tener más de 3 caracteres<br />",
  },
  "settingsSignature.form.contact.submit": {
    en: "Upload signature",
    es: "Subir Firma",
  },
  "settingsSignature.signatureDefault.tooltip": {
    en: "Required by default on proposal creation",
    es: "Firma requerida por defecto al crear un presupuesto",
  },
  "settingsTaxes.name": {
    en: "Tax name",
    es: "Nombre",
  },
  "settingsTaxes.percentage": {
    en: "Percentage",
    es: "Porcentaje",
  },
  "settingsTaxes.default": {
    en: "By default",
    es: "Por defecto",
  },
  "settingsTaxes.new": {
    en: "New",
    es: "Nuevo",
  },
  "settingsTaxesRow.form.percentage.error.number": {
    en: "It has to be a number<br />",
    es: "Debe ser un número<br />",
  },
  "settingsTaxesRow.form.percentage.error.min": {
    en: "It is too low (min: -100)<br />",
    es: "Demasiado pequeño (min: -100)<br />",
  },
  "settingsTaxesRow.form.percentage.error.max": {
    en: "It is too high (max: 100)<br />",
    es: "Demasiado grande (max: 100)<br />",
  },
  "settingsTeam.inviteToOrganization": {
    en: "Invite to business",
    es: "Invitar a la organización",
  },
  "settingsTeam.form.email.placeholder": {
    en: "Email",
    es: "Email",
  },
  "settingsTeam.form.email.error.email": {
    en: "Type a valid email (your.name@domain.com)<br/>",
    es: "Escribe un email válido (ejemplo@ejemplo.com)<br/>",
  },
  "settingsTeam.form.email.error.validateSome": {
    en: "This email has already been invited<br/>",
    es: "Este email ya ha sido invitado<br/>",
  },
  "settingsTeam.form.submit": {
    en: "Invite",
    es: "Invitar",
  },
  "settingsTeam.organizationUsers": {
    en: "Users on the business",
    es: "Usuarios de la organización",
  },
  "settingsTeam.organizationUsers.status": {
    en: "Currently using __$1__",
    es: "Estás utilizando __$1__",
  },
  "settingsTeam.organizationUsers.ownerPermissions": {
    en: "Admin access",
    es: "Permisos de administrador",
  },
  "settingsTeam.organizationUsers.ownerPermissions.tooltip": {
    en: "Admin access will allow user to get into settings window and modify all options. This will affect your business. ",
    es: "Los permisos de administrador permitirán al usuario acceder a la ventana de ajustes y modificar todas las opciones. Esto afectará a toda la organización.",
  },
  "settingsTeam.organizationUsers.role": {
    en: "Role",
    es: "Rol",
  },
  "settingsTeam.organizationUsers.remove": {
    en: "Remove User",
    es: "Eliminar Usuario",
  },
  "settingsTeam.organizationUsers.invitedAt": {
    en: "Invited on __$1__",
    es: "Invitado el __$1__",
  },
  "settingsTeam.organizationUsers.resendInvitation": {
    en: "Resend invitation",
    es: "Reenviar invitación",
  },
  "settingsTeam.organizationUsers.owner": {
    en: "Owner",
    es: "Propietario",
  },
  "settingsTeam.organizationUsers.admin": {
    en: "Administrator",
    es: "Administrador",
  },
  "settingsTeam.organizationUsers.user": {
    en: "User",
    es: "Usuario",
  },
  "profilePage.title": {
    en: "User profile",
    es: "Perfil de usuario",
  },
  "profilePage.updateProfileImage": {
    en: "Update profile image",
    es: "Actualizar foto de perfil",
  },
  "profilePage.deleteProfileImage": {
    en: "Delete profile image",
    es: "Eliminar foto de perfil",
  },
  "profilePage.profileData": {
    en: "Profile information",
    es: "Datos de perfil",
  },
  "profilePage.form.name.label": {
    en: "Name",
    es: "Nombre",
  },
  "profilePage.form.surname.label": {
    en: "Last name",
    es: "Apellidos",
  },
  "profilePage.form.name.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "profilePage.form.name.updating": {
    en: "Updating....",
    es: "Actualizando...",
  },
  "profilePage.changeEmail": {
    en: "Change email",
    es: "Cambiar email",
  },
  "profilePage.form.email.label": {
    en: "Email",
    es: "Email",
  },
  "profilePage.form.email.submit": {
    en: "Change",
    es: "Cambiar",
  },
  "profilePage.form.email.updating": {
    en: "Changing...",
    es: "Cambiando...",
  },
  "profilePage.changePassword": {
    en: "Change password",
    es: "Cambiar contraseña",
  },
  "profilePage.form.password.label": {
    en: "New password",
    es: "Nueva contraseña",
  },
  "profilePage.form.password.error.pattern": {
    en: "8 to 20 Characters, one number and one letter",
    es: "8 a 20 Caracteres, un número y una letra.<br/>",
  },
  "profilePage.form.repeatPassword.label": {
    en: "Confirm password",
    es: "Repite la contraseña",
  },
  "profilePage.form.repeatPassword.error.match": {
    en: "Passwords don't match",
    es: "La contraseña no coincide",
  },
  "profilePage.form.password.submit": {
    en: "Change",
    es: "Cambiar",
  },
  "profilePage.form.password.updating": {
    en: "Changing...",
    es: "Cambiando...",
  },
  "profilePage.notifications": {
    en: "Notifications",
    es: "Suscripciones",
  },
  "quoteTemplateEditNameModal.title": {
    en: "Rename Template",
    es: "Renombrar Plantilla",
  },
  "quoteTemplateEditNameModal.close": {
    en: "Close",
    es: "Cerrar",
  },
  "quoteTemplateImportModal.title": {
    en: "Import template",
    es: "Importar nueva plantilla",
  },
  "quoteTemplateImportModal.form.label.templateCode": {
    en: "Template code",
    es: "Código de plantilla",
  },
  "quoteTemplateImportModal.form.submit": {
    en: "Import",
    es: "Importar",
  },
  "quoteTemplateShareModal.title": {
    en: "Share Template",
    es: "Compartir plantilla",
  },
  "quoteTemplateShareModal.code": {
    en: "Template code: ",
    es: "Código:",
  },
  "quoteTemplateShareModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "quoteTemplateShareModal.toggleShare.label": {
    en: "Share this template",
    es: "Marcar como plantilla compartida",
  },
  "quoteTemplateShareModal.copyCode": {
    en: "Copy code",
    es: "Copiar código",
  },
  "templateSelectorPage.header.yourTemplates": {
    en: "Your templates",
    es: "Tus plantillas",
  },
  "templateSelectorPage.description.yourTemplates": {
    en: "These are your very own templates.",
    es: "Estas son las plantillas de presupuestos que has guardado.",
  },
  "templateSelectorPage.action.importTemplates": {
    en: "Import templates",
    es: "Importar plantillas",
  },
  "templateSelectorPage.action.importTemplates.tooltip": {
    en: 'You can import templates specially crafted by another business. Click on "Import templates" and type the template code.',
    es: 'Puedes importar plantillas ya creadas en otra organización. Para ello, pulsa en "Importar plantillas" e introduce el código de la misma.',
  },
  "templateSelectorPage.newQuote": {
    en: "+ NEW PROPOSAL",
    es: "+ NUEVO PRESUPUESTO",
  },
  "templateSelectorPage.rename.placeholder": {
    en: "Rename",
    es: "Renombrar",
  },
  "templateSelectorPage.share.placeholder": {
    en: "Share",
    es: "Compartir",
  },
  "templateSelectorPage.delete.placeholder": {
    en: "Delete",
    es: "Eliminar",
  },
  "templateSelectorPage.importedTemplate": {
    en: "Imported template",
    es: "Plantilla importada",
  },
  "costModalPricing.newCost": {
    en: "Create a new cost",
    es: "Crea un nuevo coste",
  },
  "costModalPricing.editCost": {
    en: "Edit cost",
    es: "Edita el coste",
  },
  "costModalPricing.form.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },
  "costModalPricing.form.unit.placeholder": {
    en: "Unit",
    es: "Und. de medida",
  },
  "costModalPricing.form.unit.error.required": {
    en: "Type cost unit (e.g: units, hours, metres, etc..)<br />",
    es: "Escribe la unidad de medida del coste (Ej: unidades, horas, metros, etc...)<br/>",
  },
  "costModalPricing.form.price.placeholder": {
    en: "Price",
    es: "Precio",
  },
  "costModalPricing.form.price.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "costModalPricing.form.price.error.min": {
    en: "It has to be positive<br/>",
    es: "Debe ser positivo<br/>",
  },
  "costModalPricing.form.price.error.max": {
    en: "It is too high (max: 9.999.999.999,99)<br/>",
    es: "Demasiado grande (max: 9.999.999.999,99)<br/>",
  },
  "costModalPricing.form.price.error.maxLength": {
    en: "It is too long (max: 9.999.999.999,99)<br/>",
    es: "Demasiado largo (max: 9.999.999.999,99)<br/>",
  },
  "costModalPricing.form.comments.placeholder": {
    en: "Comments",
    es: "Notas relacionadas con el coste...",
  },
  "costModalPricing.form.saveOnLibrary": {
    en: "Save to cost library",
    es: "Guardar en biblioteca",
  },
  "costModalPricing.form.updateOnLibrary": {
    en: "Update on library",
    es: "Actualizar en biblioteca",
  },
  "costModalPricing.costsLibrary": {
    en: "Costs library",
    es: "Biblioteca de Costes",
  },
  "costModalPricing.searchCosts.placeholder": {
    en: "Search on costs",
    es: "Buscar entre tus costes",
  },
  "costModalPricing.searchCosts.results": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "costModalPricing.searchCosts.noResults": {
    en: "Ouch! We couldn't find any cost with that description. <br> Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción.<br>¡Prueba otra vez!",
  },
  "costModalPricing.searchCosts.noCosts": {
    en: "There are no costs yet!",
    es: "¡Aún no tienes costes!",
  },
  "costModalPricing.searchCosts.showMore": {
    en: "Show more",
    es: "Ver más",
  },
  "date.form.placeholder": {
    en: "Pick a date",
    es: "Selecciona una fecha",
  },
  "date.form.closeText": {
    en: "Close",
    es: "Cerrar",
  },
  "date.form.clearText": {
    en: "Clear",
    es: "Borrar",
  },
  "date.form.currentText": {
    en: "Today",
    es: "Hoy",
  },
  "date.form.error.format": {
    en: "Choose a valid date.",
    es: "Escribe una fecha válida. Ej: 01/01/2016",
  },
  "date.form.error.required": {
    en: "Pick a date",
    es: "Selecciona una fecha",
  },
  "fontSelector.placeholder": {
    en: "Select a font",
    es: "Selecciona una fuente",
  },
  "fontSizeSelector.error.min": {
    en: "Minimum value is 8",
    es: "El valor mínimo es 8",
  },
  "fontSizeSelector.error.max": {
    en: "Maximum value is 128",
    es: "El valor máximo es 128",
  },
  "fontSizeSelector.error.step": {
    en: "Value has to be integer",
    es: "El valor debe ser un número entero",
  },
  "fontStyleChange.title": {
    en: "Typography",
    es: "Tipografía",
  },
  "fontStyleChange.defaultStyles.placeholder": {
    en: "If this box is unchecked, custom styling will be used as defined",
    es: "Si esta casilla está desmarcada, se utilizarán los estilos que se establezcan en esta ventana",
  },
  "fontStyleChange.defaultStyles.title": {
    en: "Default styles",
    es: "Estilos por defecto",
  },
  "fontStyleChange.applyAllSections": {
    en: "Apply to all sections",
    es: "Aplicar a todas las secciones",
  },
  "fontStyleChange.header1": {
    en: "Header 1",
    es: "Título",
  },
  "fontStyleChange.header2": {
    en: "Header 2",
    es: "Subtítulo",
  },
  "fontStyleChange.paragraph": {
    en: "Paragraph",
    es: "Párrafo",
  },
  "imageSelector.chooseImage": {
    en: "Choose image",
    es: "Elegir imagen",
  },
  "imageSelector.changeImage": {
    en: "Change image",
    es: "Cambiar imagen",
  },
  "imageSelector.removeImage": {
    en: "Remove image",
    es: "Eliminar imagen",
  },
  "imageSelectorModal.gallery": {
    en: "Gallery",
    es: "Galería",
  },
  "imageSelectorModal.description": {
    en: "Add unique images for a unique proposal. Select one from Unsplash or upload your own photos or designs.",
    es: "Añade imágenes únicas para un presupuesto único. Elige en nuestro buscador o sube tus propias fotografías o diseños.",
  },
  "imageSelectorModal.uploadFile": {
    en: "Upload file",
    es: "Subir archivo",
  },
  "imageSelectorModal.popular": {
    en: "Most popular",
    es: "Popular",
  },
  "imageSelectorModal.recent": {
    en: "Most recent",
    es: "Recientes",
  },
  "imageSelectorModal.unsplash.placeholder": {
    en: "Image search at Unsplash",
    es: "Busca fotos en Unsplash",
  },
  "imageSelectorModal.unsplash.text": {
    en: "You can search by topics or colours",
    es: "Puedes buscar por temas o colores.",
  },
  "imageSelectorModal.unsplash.english.tooltip": {
    en: "Remember to search by using English words. E.g: dog",
    es: "Recuerda hacer tus búsquedas en inglés. Ejemplo: dog",
  },
  "imageSelectorModal.select": {
    en: "Select",
    es: "Seleccionar",
  },
  "imageSelectorModal.noMoreResults": {
    en: "There are no more results",
    es: "No hay más resultados",
  },
  "imageSelectorModal.unsplash.down": {
    en: "Unsplash is temporarily not available, try again later.",
    es: "Unsplash no está disponible temporalmente, inténtalo de nuevo más tarde.",
  },
  "imageSelectorModal.reload": {
    en: "Reload",
    es: "Actualizar",
  },
  "navbarOverQuote.version": {
    en: "Version __$1__",
    es: "Versión __$1__",
  },
  "navbarOverQuote.seeVersion": {
    en: "View v__$1__",
    es: "Ver v__$1__",
  },
  "navbarOverQuote.preview": {
    en: "Preview",
    es: "Previsualizar",
  },
  "navbarOverQuote.share": {
    en: "Share",
    es: "Compartir",
  },
  "navbarOverQuote.downloadPdf": {
    en: "Download PDF",
    es: "Descargar en PDF",
  },
  "navbarOverQuote.saveTemplate": {
    en: '<i class="zmdi zmdi-file"></i> Save template',
    es: '<i class="zmdi zmdi-file"></i> Guardar plantilla',
  },
  "navbarOverQuote.delete": {
    en: '<i class="zmdi zmdi-delete"></i> Delete',
    es: '<i class="zmdi zmdi-delete"></i> Eliminar',
  },
  "navbarOverQuote.lastSavedTime": {
    en: "Saved for the last time on __$1__",
    es: "Guardado por última vez el __$1__",
  },
  "placeholderModal.header": {
    en: "Placeholders",
    es: "Variables",
  },
  "placeholderModal.description": {
    en: "Placeholders are intented to include information in your proposal. E.g: If you want to add your contact's name, copy the corresponding placeholder <code>{{contact_name}}</code> and paste it into the document.",
    es: "Las variables sirven para incluir datos de manera rápida en tu presupuesto. Por ejemplo: si quieres añadir el nombre de tu contacto, copia la variable correspondiente <code>{{contacto_nombre}}</code> y pégala en el documento.",
  },
  "placeholderModal.description.optional": {
    en: "Optional: Optional placeholders will not be substituted if they do not have a related value.",
    es: "Opcional: Las variables opcionales no se sustuirán si no tienen un valor asociado.",
  },
  "placeholderModal.quote": {
    en: "Proposal",
    es: "Presupuesto",
  },
  "placeholderModal.quote.description": {
    en: "{{quote_description}}",
    es: "{{presupuesto_descripcion}}",
  },
  "placeholderModal.quote.code": {
    en: "{{quote_code}}",
    es: "{{presupuesto_codigo}}",
  },
  "placeholderModal.quote.date": {
    en: "{{quote_date}}",
    es: "{{presupuesto_fecha}}",
  },
  "placeholderModal.quote.expiration_date": {
    en: "{{quote_expiration_date}}",
    es: "{{presupuesto_fecha_validez}}",
  },
  "placeholderModal.quote.version": {
    en: "{{quote_version}}",
    es: "{{presupuesto_version}}",
  },
  "placeholderModal.organization": {
    en: "Business",
    es: "Organización",
  },
  "placeholderModal.organization.name": {
    en: "{{business_name}}",
    es: "{{organizacion_nombre}}",
  },
  "placeholderModal.organization.address": {
    en: "{{business_address}}",
    es: "{{organizacion_direccion}}",
  },
  "placeholderModal.placeholder.optional": {
    en: "(optional)",
    es: "(opcional)",
  },
  "placeholderModal.organization.address_2": {
    en: "{{business_address_2}}",
    es: "{{organizacion_direccion_2}}",
  },
  "placeholderModal.organization.state": {
    en: "{{business_state}}",
    es: "{{organizacion_provincia}}",
  },
  "placeholderModal.organization.city": {
    en: "{{business_city}}",
    es: "{{organizacion_ciudad}}",
  },
  "placeholderModal.organization.country": {
    en: "{{business_country}}",
    es: "{{organizacion_pais}}",
  },
  "placeholderModal.organization.zip": {
    en: "{{business_zip}}",
    es: "{{organizacion_cp}}",
  },
  "placeholderModal.organization.web": {
    en: "{{business_web}}",
    es: "{{organizacion_web}}",
  },
  "placeholderModal.contact": {
    en: "Contact",
    es: "Contacto",
  },
  "placeholderModal.contact.email": {
    en: "{{contact_email}}",
    es: "{{contacto_email}}",
  },
  "placeholderModal.contact.name": {
    en: "{{contact_name}}",
    es: "{{contacto_nombre}}",
  },
  "placeholderModal.contact.lastName": {
    en: "{{contact_last_name}}",
    es: "{{contacto_apellidos}}",
  },
  "placeholderModal.contact.primaryPhone": {
    en: "{{contact_primary_phone}}",
    es: "{{contacto_tlf_principal}}",
  },
  "placeholderModal.contact.secondaryPhone": {
    en: "{{contact_secondary_phone}}",
    es: "{{contacto_tlf_secundario}}",
  },
  "placeholderModal.contact.appointment": {
    en: "{{contact_appointment}}",
    es: "{{contacto_cargo}}",
  },
  "placeholderModal.contact.company": {
    en: "{{contact_business_name}}",
    es: "{{contacto_empresa}}",
  },
  "placeholderModal.contact.nif": {
    en: "{{contact_id_number}}",
    es: "{{contacto_nif}}",
  },
  "placeholderModal.contact.address": {
    en: "{{contact_address}}",
    es: "{{contacto_direccion}}",
  },
  "placeholderModal.contact.address_2": {
    en: "{{contact_address_2}}",
    es: "{{contacto_direccion_2}}",
  },
  "placeholderModal.contact.city": {
    en: "{{contact_city}}",
    es: "{{contacto_ciudad}}",
  },
  "placeholderModal.contact.state": {
    en: "{{contact_state}}",
    es: "{{contacto_provincia}}",
  },
  "placeholderModal.contact.country": {
    en: "{{contact_country}}",
    es: "{{contacto_pais}}",
  },
  "placeholderModal.contact.zip": {
    en: "{{contact_zip}}",
    es: "{{contacto_cp}}",
  },
  "placeholderModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "placeholderModal.noValue": {
    en: "No value",
    es: "No establecido",
  },
  "sectionGalleryModal.header": {
    en: "Sections from your library",
    es: "Secciones de tu biblioteca",
  },
  "sectionGalleryModal.body.noSections": {
    en: "You don't have any saved sections! <br /> Do it on section options.",
    es: "¡Aún no tienes secciones!<br />Puedes guardarlas desde opciones de sección.",
  },
  "sectionGalleryModal.searchBar.placeholder": {
    en: "Search by name",
    es: "Buscar por nombre",
  },
  "sectionGalleryModal.sortBy": {
    en: "Order by:",
    es: "Ordenar por:",
  },
  "sectionGalleryModal.sortBy.name": {
    en: "name",
    es: "nombre",
  },
  "sectionGalleryModal.sortBy.date": {
    en: "date",
    es: "fecha",
  },
  "sectionGalleryModal.action.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "sectionGalleryModal.action.rename": {
    en: "Rename",
    es: "Renombrar",
  },

  "pricingTable.description": {
    en: "Description",
    es: "Descripción",
  },
  "pricingTable.quantity": {
    en: "Quantity",
    es: "Cantidad",
  },
  "pricingTable.price": {
    en: "Price",
    es: "Precio",
  },
  "pricingTable.margin": {
    en: "Margin (%)",
    es: "Margen (%)",
  },
  "pricingTable.discount": {
    en: "Disc (%)",
    es: "Dto (%)",
  },
  "pricingTable.optional": {
    en: "Optional",
    es: "Opcional",
  },
  "pricingTable.costsOnTariff.placeholder": {
    en: "This proposal line has related costs",
    es: "Esta línea de presupuesto tiene costes asociados",
  },
  "pricingTable.selectedByClient.default.placeholder": {
    en: "Selected by default",
    es: "Seleccionada por defecto",
  },
  "pricingTable.selectedByClient.notDefault.placeholder": {
    en: "No selected by default",
    es: "No seleccionada por defecto",
  },
  "pricingTable.addTariffToLibrary": {
    en: "Add this rate to the library",
    es: "Añadir esta tarifa a la biblioteca",
  },
  "pricingTable.updateTariffOnLibrary": {
    en: "Update rate on library",
    es: "Actualizar tarifa en biblioteca",
  },
  "pricingTable.moveUp": {
    en: "Move up",
    es: "Mover hacia arriba",
  },
  "pricingTable.moveDown": {
    en: "Move down",
    es: "Mover hacia abajo",
  },
  "pricingTable.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "pricingTable.cost.description": {
    en: "Cost Description",
    es: "Descripción Coste",
  },
  "pricingTable.cost.quantity": {
    en: "Quantity",
    es: "Cantidad",
  },
  "pricingTable.cost.price": {
    en: "Price",
    es: "Precio",
  },
  "pricingTable.cost.unitPrice": {
    en: "Unit price",
    es: "Coste/Unidad Tarifa",
  },
  "pricingTable.cost.total": {
    en: "Total",
    es: "Total Coste",
  },
  "pricingTable.cost.total.tooltip": {
    en: "This is the product of the total cost for the amount of the rate",
    es: "Esto es el producto del coste total por la cantidad de la tarifa",
  },
  "pricingTable.cost.add": {
    en: "Add new cost",
    es: "Añadir un nuevo coste",
  },
  "pricingTable.tariff.add": {
    en: "Add item",
    es: "Añadir tarifa",
  },
  "pricingTable.showTotalTaxes": {
    en: "Show Total and Taxes",
    es: "Mostrar Total e Impuestos",
  },
  "pricingTable.totalTaxes": {
    en: "Total and taxes",
    es: "Total e impuestos",
  },
  "pricingTable.totalCosts": {
    en: "TOTAL COST",
    es: "TOTAL DE COSTES",
  },
  "pricingTable.totalMargin": {
    en: "PROFIT MARGIN",
    es: "MARGEN DE BENEFICIO",
  },
  "pricingTable.subtotal": {
    en: "SUBTOTAL",
    es: "SUBTOTAL",
  },
  "pricingTable.addTax": {
    en: "Add tax",
    es: "Añadir impuesto",
  },
  "pricingTable.taxCustom": {
    en: "Custom",
    es: "Personalizado",
  },
  "pricingTable.total": {
    en: "TOTAL",
    es: "TOTAL",
  },
  "pricingTable.form.error.quantity.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.quantity.min": {
    en: "The number has to be positive",
    es: "El número debe ser positivo",
  },
  "pricingTable.form.error.quantity.max": {
    en: "Number is too high (max: 9.999.999.99)",
    es: "Este número es demasiado alto (max: 9.999.999.99)",
  },
  "pricingTable.form.error.quantity.maxLength": {
    en: "Number is too long (max: 9.999.999,99)",
    es: "Este número es demasiado largo (max: 9.999.999,99)",
  },
  "pricingTable.form.error.price.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.price.min": {
    en: "Number has to be positive or zero",
    es: "El número debe ser positivo o cero",
  },
  "pricingTable.form.error.price.max": {
    en: "Number is too high (max: 9.999.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999.999,99)",
  },
  "pricingTable.form.error.margin.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.margin.max": {
    en: "Number is too high (max: 10.000)",
    es: "Este número es demasiado alto (max: 10.000)",
  },
  "pricingTable.form.error.discount.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.discount.max": {
    en: "Number is too high (max: 100)",
    es: "Este número es demasiado alto (max: 100)",
  },
  "pricingTable.form.error.costQuantity.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.costQuantity.min": {
    en: "Number has to be positive",
    es: "El número debe ser positivo",
  },
  "pricingTable.form.error.costQuantity.max": {
    en: "Number is too high (max: 9.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999,99)",
  },
  "pricingTable.form.error.costQuantity.maxLength": {
    en: "Number is too high (max: 9.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999,99)",
  },
  "pricingTable.form.error.taxPercentage.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.taxPercentage.max": {
    en: "Number is too high (max: 100)",
    es: "Este número es demasiado alto (max: 100)",
  },
  "pricingTable.form.error.taxPercentage.min": {
    en: "Number is too low (min: -100)",
    es: "Este número es demasiado pequeño (min: -100)",
  },
  "pricingTableModal.header": {
    en: "Pricing Table",
    es: "Tabla de Precios",
  },
  "pricingTableModal.exchangesUpdated": {
    en: "Exchange rate were updated on __$1__",
    es: "Tipos de cambio actualizados por última vez el __$1__",
  },
  "pricingTableModal.updateExchanges": {
    en: "Update exchange rates!",
    es: "¡Actualizar tipos de cambio!",
  },
  "pricingTablePreview.tooltip": {
    en: "Click to edit",
    es: "Clic para editar",
  },
  "pricingTablePreview.edit": {
    en: "Click to edit pricing table",
    es: "Haz clic aquí para editar la tabla de precios",
  },
  "pricingTablePreview.unit": {
    en: "Unit",
    es: "Und",
  },
  "quoteActivity.header": {
    en: "Recent actitvity",
    es: "Actividad reciente",
  },
  "quoteActivity.create": {
    en: "Proposal <strong>created</strong> by __$1__",
    es: "__$1__ <strong>creó</strong> el presupuesto",
  },
  "quoteActivity.changeToApproved": {
    en: '__$1__ changed proposal status to <strong class="text-success">accepted</strong>',
    es: '__$1__ cambió el estado del presupuesto a <strong class="text-success">aceptado</strong>',
  },
  "quoteActivity.changeToRejected": {
    en: '__$1__ changed the proposal status to <strong class="text-success">rejected</strong>',
    es: '__$1__ cambió el estado del presupuesto a <strong class="text-danger">rechazado</strong>',
  },
  "quoteActivity.approve": {
    en: 'Proposal was <strong class="text-success">accepted</strong>',
    es: 'Han <strong class="text-success">aceptado</strong> el presupuesto',
  },
  "quoteActivity.reject": {
    en: 'Proposal was <strong class="text-success">rejected</strong>',
    es: 'Han <strong class="text-danger">rechazado</strong> el presupuesto',
  },
  "quoteActivity.getPublicView": {
    en: "Proposal <strong>public view</strong> was visited",
    es: "Se ha visitado la <strong>vista pública</strong> del presupuesto",
  },
  "quoteActivity.createNewVersion": {
    en: "A new proposal <strong>version was created</strong> by __$1__",
    es: "__$1__ <strong>creó una nueva version</strong> del presupuesto",
  },
  "quoteActivity.share": {
    en: "Proposal was <strong>shared</strong> by __$1__",
    es: "__$1__ <strong>compartió</strong> el presupuesto",
  },
  "quoteActivity.unshare": {
    en: "Proposal was <strong>unshared</strong> by __$1__",
    es: "__$1__ <strong>dejó de compartir</strong> el presupuesto",
  },
  "quoteActivity.archive": {
    en: "Proposal was <strong>archived</strong> by __$1__",
    es: "__$1__ <strong>archivó</strong> el presupuesto",
  },
  "quoteActivity.unarchive": {
    en: "Proposal was <strong>unarchived</strong> by __$1__",
    es: "__$1__ <strong>reactivó</strong> el presupuesto",
  },
  "quoteHeaderModal.header.new": {
    en: "Start a new proposal here",
    es: "Aquí comienza tu nuevo presupuesto",
  },
  "quoteHeaderModal.header.edit": {
    en: "Edit proposal",
    es: "Editar presupuesto",
  },
  "quoteHeaderModal.form.description.label": {
    en: "Proposal title*",
    es: "Título del presupuesto*",
  },
  "quoteHeaderModal.form.description.placeholder": {
    en: "Web site design",
    es: "Diseño de página web",
  },
  "quoteHeaderModal.form.contact.label": {
    en: "Contact*",
    es: "Contacto*",
  },
  "quoteHeaderModal.form.contact.select.empty": {
    en: "There are no contacts yet",
    es: "Aún no tienes ningún contacto",
  },
  "quoteHeaderModal.form.contact.select.any": {
    en: "Choose a contact",
    es: "Selecciona un contacto",
  },
  "quoteHeaderModal.form.contact.create": {
    en: "NEW CONTACT",
    es: "NUEVO CONTACTO",
  },
  "quoteHeaderModal.form.additionalData": {
    en: "More information",
    es: "Más datos",
  },
  "quoteHeaderModal.form.currency.label": {
    en: "Currency",
    es: "Divisa",
  },
  "quoteHeaderModal.form.quoteNumber.label": {
    en: "Proposal number",
    es: "Número de presupuesto",
  },
  "quoteHeaderModal.form.quotePrefix.label": {
    en: "Proposal prefix",
    es: "Prefijo de presupuesto",
  },
  "quoteHeaderModal.form.quoteNumber.prefix.choose": {
    en: "Choose other",
    es: "Elegir otro",
  },
  "quoteHeaderModal.form.quoteNumber.prefix.noPrefix": {
    en: "(No prefix)",
    es: "(Sin prefijo)",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.maxLength": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.max": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.min": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.valueGreaterOrEqualThan": {
    en: "It has to be equal or higher than __$1__<br/>",
    es: "Debe ser mayor o igual que __$1__<br/>",
  },
  "quoteHeaderModal.form.language.label": {
    en: "Language",
    es: "Idioma",
  },
  "quoteHeaderModal.form.date.label": {
    en: "Date",
    es: "Fecha",
  },
  "quoteHeaderModal.form.date.error.date": {
    en: "It's not a valid date",
    es: "No es una fecha válida",
  },
  "quoteHeaderModal.form.expirationDate.label": {
    en: "Expiration date",
    es: "Válido hasta",
  },
  "quoteHeaderModal.form.expirationDate.error.date": {
    en: "It's not a valid date",
    es: "No es una fecha válida",
  },
  "quoteHeaderModal.form.emailToCustomerOnAccept": {
    en: "Send email to customer when accepts",
    es: "Enviar email al cliente cuando acepte",
  },
  "quoteHeaderModal.form.pdfDownloadable": {
    en: "PDF downloadable by client",
    es: "PDF descargable por el cliente",
  },
  "quoteHeaderModal.form.approveFromPublicView": {
    en: "Allow to accept proposal online",
    es: "Permitir aceptar presupuesto online",
  },
  "quoteHeaderModal.form.approveFromPublicView.tooltip": {
    en: 'When it\'s selected the "Accept" button will be visible on public view.',
    es: "Al seleccionarlo, aparecerá en la vista pública el botón de “Aceptar” presupuesto.",
  },
  "quoteHeaderModal.form.signature.tooltip": {
    en: "To use signature feature, go to Settings --> Proposals and configure it for your business there.",
    es: "Para poder usar esta opción es necesario que el dueño de la organización establezca una firma en Ajustes -> Presupuestos.",
  },
  "quoteHeaderModal.form.signature": {
    en: "Signature required to accept the proposal",
    es: "Requerir firma para aceptar el presupuesto",
  },
  "quoteHeaderModal.form.signature.info": {
    en: "You can require your client to digitally sign you proposal to accept it.",
    es: "Puedes pedir a tu cliente que utilice nuestra firma digital para aceptar el presupuesto.",
  },
  "quoteHeaderModal.form.submit": {
    en: "Let's go!",
    es: "¡ADELANTE!",
  },
  "quoteHeaderModal.close": {
    en: "Close",
    es: "Cancelar",
  },

  "quoteNewSection.header.title": {
    en: "Create a new section",
    es: "Crea una nueva sección",
  },
  "quoteNewSection.header.description": {
    en: "Add a new section. Include your rates or reuse the sections that you have saved in other proposals.",
    es: "Añade una nueva sección. Incluye tus tarifas o reutiliza las secciones que hayas guardado en otros presupuestos.",
  },
  "quoteNewSection.header.cancel": {
    en: "Cancel",
    es: "Cancelar",
  },
  "quoteNewSection.type.text": {
    en: "Text, images or videos.",
    es: "Texto, fotos o vídeos",
  },
  "quoteNewSection.type.pricingTable": {
    en: "Pricing table",
    es: "Tabla de precios",
  },
  "quoteNewSection.type.gallery": {
    en: "Saved sections",
    es: "Secciones guardadas",
  },

  "quoteSection.save.label": {
    en: "Save section",
    es: "Guardar sección",
  },

  "quoteSection.background.label": {
    en: "Background",
    es: "Fondo",
  },
  "quoteSection.typography.label": {
    en: "Typography",
    es: "Tipografía",
  },
  "quoteSection.delete.label": {
    en: "Delete",
    es: "Eliminar",
  },
  "quoteSection.moveDown.placeholder": {
    en: "Move down",
    es: "Mover abajo",
  },
  "quoteSection.moveUp": {
    en: "Move up",
    es: "Mover arriba",
  },
  "quoteSection.fullScreen": {
    en: "Expand",
    es: "Expandir",
  },
  "quoteSection.autoSize": {
    en: "Auto size",
    es: "Tamaño automático",
  },
  "quoteSection.cancel": {
    en: "Cancel",
    es: "Cancelar",
  },
  "quoteSection.newSection": {
    en: "New section",
    es: "Nueva sección",
  },

  "quoteSectionNameForm.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },

  "quoteSectionNameModal.header": {
    en: "Section name",
    es: "Nombre de sección",
  },

  "quoteShareModal.shareThrough": {
    en: "Share through:",
    es: "Compartir mediante:",
  },
  "quoteShareModal.header.title": {
    en: "Share",
    es: "Compartir",
  },
  "quoteShareModal.publicUrl": {
    en: "Public URL:",
    es: "URL pública:",
  },
  "quoteShareModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "quoteShareModal.toggleShare.label": {
    en: "Make this proposal public to your client",
    es: "Marcar como presupuesto visible para tu cliente",
  },
  "quoteShareModal.toggleShare.info": {
    en: "You can generate the proposal privately (only accessible by your business users) or make it public to your client.",
    es: "Puedes generar el presupuesto en privado (sólo accesible a tu organización) o bien hacerlo público para tu cliente.",
  },
  "quoteShareModal.copyLink": {
    en: "Copy link",
    es: "Copiar enlace",
  },
  "quoteShareModal.email.subject": {
    en: "Proposal from __$1__",
    es: "Presupuesto de __$1__",
  },
  "quoteShareModal.email.body": {
    en: "Hi __$1__,%0D%0A%0D%0AI am sending you the proposal we were working on. Visit it via this link:%0D%0A%0D%0A__$2__%0D%0A%0D%0AGreetings",
    es: "Hola __$1__,%0D%0A%0D%0ATal y como nos has solicitado, a continuación te envío el presupuesto. Lo puedes ver a través de este enlace:%0D%0A%0D%0A__$2__%0D%0A%0D%0ASaludos",
  },

  "quoteTemplateCreateOverwriteModal.header": {
    en: "New template",
    es: "Nueva plantilla",
  },
  "quoteTemplateCreateOverwriteModal.update": {
    en: "Update template",
    es: "Actualizar Plantilla",
  },

  "quoteTemplateNameForm.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },

  "sectionBackgroundSelector.header": {
    en: "Background",
    es: "Fondo",
  },
  "sectionBackgroundSelector.color": {
    en: "Colour",
    es: "Color",
  },
  "sectionBackgroundSelector.image": {
    en: "Image",
    es: "Imagen",
  },
  "sectionBackgroundSelector.video": {
    en: "Video",
    es: "Vídeo",
  },
  "sectionBackgroundSelector.color.main": {
    en: "Main",
    es: "Principal",
  },
  "sectionBackgroundSelector.color.secondary": {
    en: "Secondary",
    es: "Secundario",
  },
  "sectionBackgroundSelector.color.other": {
    en: "Overlay",
    es: "Overlay",
  },
  "sectionBackgroundSelector.color.none": {
    en: "None",
    es: "Ninguno",
  },
  "sectionBackgroundSelector.changeColors": {
    en: 'You can change this colours on <a href="__$1__">business settings.</a>',
    es: 'Puedes cambiar estos colores en la <a href="__$1__">configuración de la organización.</a>',
  },
  "sectionBackgroundSelector.video.soundEnabled": {
    en: "Sound on",
    es: "Sonido activado",
  },
  "sectionBackgroundSelector.video.set": {
    en: "Set",
    es: "Establecer",
  },
  "sectionBackgroundSelector.video.delete": {
    en: "Delete",
    es: "Eliminar",
  },
};
